import { render, staticRenderFns } from "./cordx-one-step-hcg-pregnancy-test-cassette.vue?vue&type=template&id=0653c70f&scoped=true&"
import script from "./cordx-one-step-hcg-pregnancy-test-cassette.vue?vue&type=script&lang=js&"
export * from "./cordx-one-step-hcg-pregnancy-test-cassette.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0653c70f",
  null
  
)

export default component.exports